import { render, staticRenderFns } from "./ProductWeergave.vue?vue&type=template&id=430595e6&scoped=true&"
import script from "./ProductWeergave.vue?vue&type=script&lang=ts&"
export * from "./ProductWeergave.vue?vue&type=script&lang=ts&"
import style0 from "./ProductWeergave.vue?vue&type=style&index=0&id=430595e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430595e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VRow})
